<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type} ini-slider  ini-slider-is--${sliderIsEnabled ? 'enabled' : 'disabled'}`"
    :data-type="context.type"
  >
    <div class="slider-help--min">
      min
      <span class="value">{{ this.min | toCurrencyShort }}</span>
    </div>
    <FormulateInput
      type="range"
      step="100"
      :name="`${context.name}`"
      :min="`${this.min}`"
      :max="`${this.max}`"
      v-model="context.model"
      v-bind="context.attributes"
      @change="sliderChange"

    />
    <div class="slider-help--max">
      max
      <span class="value">{{ this.max | toCurrencyShort }}</span>
    </div>
    <div class="agreed-value">
      <span>$ {{ this.vehicle_sum_insured | toCurrencyNoSymbolShort }}</span>
      Agreed value 
        <!-- TODO: put this in its own <object> or vue component -->
        <!-- TODO: pull tooltip from schema -->
        <svg
        v-tooltip="{ content: 'This is the \'agreed value\' – it\'s the amount (inc GST) you choose to insure your car for. Maximum and Minimum limits are set based on the type of car, and you can choose any value in that range. You can use the slider to choose a value you believe best represents the current value of your car' }"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 21 21"
        class="tooltip-icon"
      >
          <path d="M10.261 9.06152H10.743C11.0078 9.06152 11.2219 9.32625 11.2219 9.54034V15.2957C11.2219 15.5604 11.0078 15.7745 10.743 15.7745H10.261C9.99632 15.7745 9.78223 15.5098 9.78223 15.2957V9.54034C9.78223 9.27561 9.99633 9.06152 10.261 9.06152Z" />
          <path d="M10.261 5.70801H10.743C11.0078 5.70801 11.2219 5.97273 11.2219 6.18683V7.14765C11.2219 7.41238 11.0078 7.62647 10.743 7.62647H10.261C9.99632 7.62647 9.78223 7.36174 9.78223 7.14765V6.18683C9.78223 5.9221 9.99633 5.70801 10.261 5.70801Z" />
          <path d="M10.5005 19.1279C12.7892 19.1279 14.9831 18.2198 16.6009 16.6008C18.2199 14.9829 19.128 12.7892 19.128 10.5004C19.128 8.21164 18.2199 6.01789 16.6009 4.40005C14.983 2.78111 12.7893 1.87302 10.5005 1.87302C8.21175 1.87302 6.018 2.78111 4.40016 4.40005C2.78122 6.01795 1.87313 8.21164 1.87313 10.5004C1.87313 12.7892 2.78122 14.983 4.40016 16.6008C6.01806 18.2198 8.21175 19.1279 10.5005 19.1279ZM10.5005 20.5664V20.5675C7.83113 20.5675 5.27037 19.5065 3.38253 17.6186C1.49464 15.7307 0.433594 13.1698 0.433594 10.5005C0.433594 7.83133 1.49461 5.27037 3.38253 3.38253C5.27043 1.49464 7.83132 0.433594 10.5005 0.433594C13.1698 0.433594 15.7307 1.49461 17.6186 3.38253C19.5064 5.27043 20.5675 7.83133 20.5675 10.5005C20.5675 13.1698 19.5065 15.7307 17.6186 17.6186C15.7307 19.5064 13.1698 20.5675 10.5005 20.5675V20.5664Z" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toCurrency } from '../../../helpers/currencyHelper';

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      min: 0,
      max: 0,
      avg: 0,
      max_insurable: 150000, // move this to backend?
      lastValueBeforeDisabled: 0,
    }
  },
  watch: {
    model () {
      
    },
    // Watch the slider, set the value to 0 if the slider isn't enabled ( when not full-cover )
    sliderIsEnabled(sliderIsEnabled) {

      // console.log( "this.context.model", parseInt(this.context.model));

      if ( sliderIsEnabled && parseInt(this.context.model) === 0 ){
        if (this.lastValueBeforeDisabled == 0) {
          this.context.model = this.avg;
        } else {
          this.context.model = this.lastValueBeforeDisabled;
        }
      } else if (!sliderIsEnabled) {
        // console.log('watch sliderIsEnabled()');

        this.lastValueBeforeDisabled = this.context.model;
        this.context.model = 0;
      }
    }
  },
  beforeMount() {
    // console.log('beforeMount', this.context.model);
    // console.log('beforeMount', this.answers['Vehicle.Plate'].vehicle_price_avg);
    
    this.min = this.answers[this.getStep('plate')].vehicle_price_low;
    this.avg = this.answers[this.getStep('plate')].vehicle_price_avg;
    this.max = this.answers[this.getStep('plate')].vehicle_price_high;

    if ( this.min > this.max_insurable ) {
      this.min = this.max_insurable;
    }
    
    if ( this.max > this.max_insurable ) {
      this.max = this.max_insurable;
    }

    // Set a proper default value if no value on model
    if( this.context.model ){
      if ( this.context.model > this.max ) {
        this.context.model = this.getDefaultValue();
      }
      if ( this.context.model < this.min ) {
        this.context.model = this.getDefaultValue();
      }
    } else if ( this.sliderIsEnabled ) {
      this.context.model = this.getDefaultValue();
    } else {
      this.context.model = 0;
    }
  },
  computed: {
      model () {
        return this.context.model
      },
      ...mapGetters({ answers: 'flattenedAnswers', getStep: 'getStep' }),
      vehicle_sum_insured: {
        get () {
          // this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_min = 25600;
          // this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_max = 29600;

          // let range = this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_max - this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_min;
          // let range = this.max - this.min;

          // return Math.floor( this.min + (( this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_percent / 100) * range ) ).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          // return this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_min + (( this.$store.getters.flattenedAnswers['Vehicle.Quote'].vehicle_sum_insured_percent / 100) * range );
          // console.log(this);

          return ( this.context.model ?? this.max ) | this.toCurrencyNoSymbol;
        }
      },
      sliderIsEnabled(){
        if( ! this.answers || !this.answers[this.getStep('quote')] || !this.answers[this.getStep('quote')].vehicle_cover_type ){
          return false;
        }
        return this.answers[this.getStep('quote')].vehicle_cover_type !== 'third-party-only'
      }
  },
  methods: {
    // Store slider value so we can jump back to that value if the user changes cover type 
    // away from full-cover, then back to full cover ( restore last selected value)
    sliderChange(change){
       if( this.sliderIsEnabled ){
         this.lastValueBeforeDisabled = this.context.model;
       }
    },
    getDefaultValue(){
        //const middle = this.min + ((this.max - this.min) / 2);
        if ( this.answers[this.getStep('plate')].sum_insured_default ) {
          return this.answers[this.getStep('plate')].sum_insured_default;
        }

        if ( this.answers[this.getStep('plate')].vehicle_price_avg > this.max_insurable ) {
          return this.max_insurable;
        }
        return Math.ceil( this.answers[this.getStep('plate')].vehicle_price_avg /100)*100; // round up to closest 100
    }
  }
}
</script>

<style lang="scss">

.ini-slider {
  opacity: 1;
  transition: opacity .2s ease-in;
  animation-direction: 0.1s;
}
.ini-slider-is--disabled {
  opacity: 0.3;
  pointer-events: none;
}
.tooltip-icon {
    width: 1.25em;
    height: 1.25em;
    fill: #00A7FF;
    margin-left: .5em;
    display: inline-block;
    vertical-align: middle;
}

[data-type=vehiclecoverslider] {

  .formulate-input-wrapper {
    width:100%;
  }

  display:flex;
  justify-content: space-between;
  align-items: center;

  @include mobile(){
    flex-wrap: wrap;
  }

  .slider-help--min, .slider-help--max {
    font-size:0.8rem;
    color:rgba(113, 127, 134, 1);
    margin-right:0.5rem;

    > span {
      display:block;
    }
  }

  .slider-help--max {
    text-align:right;
    margin-right:0;
    margin-left:0.5rem;
  }

  .formulate-input[data-classification=slider] {
      max-width:50%;
      flex-grow:1;
      flex-shrink:1;
      @include mobile(){
        max-width: 70%;
      }
  }

  .agreed-value {
    padding:10px 20px;
    border:1px solid rgba(223, 227, 232, 1);
    background:rgba(242, 242, 242, 1);
    border-radius:4px;
    margin-left:1rem;

    @include mobile(){
      margin-left: 0;
      margin-top: 0.5rem;
      width: 100%;
    }

    > span {
      font-weight:900;
    }
  }
}
</style>